import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

const PACCHETTI = ['Base', 'Medium', 'Collisione+Medium', 'Kasko+Medium']
const ZONE = ['1', '2', '3', '3bis', '4']
const DURATE = [12, 24, 36, 48, 60]

export default function AdminCoveaTassi() {
  const [tassi, setTassi] = useState([])
  const [edits, setEdits] = useState({})
  const [zona, setZona] = useState('1')
  const [conSat, setConSat] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('covea_tassi').select('*')
    setTassi(data || [])
    setLoading(false)
  }

  function k(z, pacchetto, durata, sat) { return `${z}||${pacchetto}||${durata}||${sat}` }

  function getVal(z, pacchetto, durata, sat) {
    const key = k(z, pacchetto, durata, sat)
    if (edits[key] !== undefined) return edits[key]
    const row = tassi.find(t =>
      t.zona === z && t.pacchetto === pacchetto && t.durata_mesi === durata && t.con_sat === sat)
    return row != null ? row.tasso : ''
  }

  async function saveAll() {
    setSaving(true)
    for (const [key, val] of Object.entries(edits)) {
      const [z, pacchetto, durata, sat] = key.split('||')
      await supabase.from('covea_tassi')
        .update({ tasso: parseFloat(val) })
        .eq('zona', z)
        .eq('pacchetto', pacchetto)
        .eq('durata_mesi', parseInt(durata))
        .eq('con_sat', sat === 'true')
    }
    setEdits({})
    clearTariffeCache()
    await load()
    setSaving(false)
  }

  if (loading) return <div className="loading">Caricamento...</div>
  const dirty = Object.keys(edits).length > 0

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Tassi Covea (poliennale)</h1>
          <p>Tariffe Tutelauto livello 3 (imposte e commissioni broker incluse nel tasso). Formula: <strong>tasso × valore/1000 + 40€ diritti fissi</strong>, poi × (1 + commissione dealer).</p>
        </div>
        {dirty && (
          <button className="btn btn-primary" onClick={saveAll} disabled={saving}>
            {saving ? 'Salvataggio...' : `Salva ${Object.keys(edits).length} modifiche`}
          </button>
        )}
      </div>

      <div className="card">
        <div className="tabs">
          {ZONE.map(z => (
            <div key={z} className={`tab ${zona === z ? 'active' : ''}`} onClick={() => setZona(z)}>
              Zona {z}
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', padding: '1rem 1rem 0' }}>
          <button
            className={`btn ${!conSat ? 'btn-primary' : 'btn-sm'}`}
            onClick={() => setConSat(false)}
          >
            Senza satellitare
          </button>
          <button
            className={`btn ${conSat ? 'btn-primary' : 'btn-sm'}`}
            onClick={() => setConSat(true)}
          >
            Con satellitare
          </button>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Pacchetto</th>
                {DURATE.map(d => <th key={d}>{d} mesi</th>)}
              </tr>
            </thead>
            <tbody>
              {PACCHETTI.map(p => (
                <tr key={p}>
                  <td><strong>{p}</strong></td>
                  {DURATE.map(d => {
                    const key = k(zona, p, d, conSat)
                    const val = getVal(zona, p, d, conSat)
                    const isDirty = edits[key] !== undefined
                    return (
                      <td key={d}>
                        <input
                          type="number" step="0.0001" value={val}
                          onChange={e => setEdits(s => ({ ...s, [key]: e.target.value }))}
                          style={{ width: 100, background: isDirty ? '#FFF7E5' : 'transparent' }}
                        />
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
